import React from "react";

import { Button } from "@mui/material";
import InputSelectionComponent from "../Dashboard/Component/inputSelection";

import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import RadioButtonsGroup from "../../Component/UI/RadioGroup/RadioGroup";

const RADIO_OPTIONS = [
  {
    value: "Company/Brand",
    label: "Brand",
  },
  {
    value: "Product",
    label: "Product",
  },
];

const DashboardNav = ({
  selectedOptionShow,
  contentTypes,
  brandItems,
  selectedBrandItems,
  handleBrandCheckChange,
  handleProductCheckChange,
  selectedProductItems,
  productItems,
  isFirstTime,
  selectedPersona,
  handlePersonaCheckChange,
  personas,
  selectedGeographyItems,
  handleGeographyCheckChange,
  geography,
  selectedMarketItems,
  handleMarketCheckChange,
  markets,
  selectedLlmItems,
  handleLlmCheckChange,
  dbLlms,
  showData,
  isDone,
  handleClickShow,
  filterModalType,
  showNav = true,
  setSelectedOptionShow,
  categories,
  handleCategoryCheckChange,
  selectedCategory,
}) => {
  const handleTypeChange = (value) => {
    setSelectedOptionShow(value);
  };
  return (
    <>
      <div>
        <RadioButtonsGroup
          options={RADIO_OPTIONS}
          onChange={handleTypeChange}
        />
      </div>

      <div className="customTabContent tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="nav-competition-tab"
        >
          <div className="row">
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-briefcase"></i>
                </span>
                {selectedOptionShow === "Company/Brand" ? (
                  <InputSelectionComponent
                    options={brandItems}
                    selectedOptions={selectedBrandItems}
                    handleChange={handleBrandCheckChange}
                    // type="brand"
                  />
                ) : (
                  <InputSelectionComponent
                    options={productItems}
                    selectedOptions={selectedProductItems}
                    handleChange={handleProductCheckChange}
                    // type="product"
                  />
                )}
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedCategory}
                  handleChange={handleCategoryCheckChange}
                  options={categories}
                  // type="category"
                />
              </div>
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedPersona}
                  handleChange={handlePersonaCheckChange}
                  options={personas}
                  // type="persona"
                />
              </div>
            </div>

                   <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedGeographyItems}
                  handleChange={handleGeographyCheckChange}
                  options={geography}
                  type="geography"
                />
              </div>
            </div>
          </div>
          <div className="row mt-1">
     
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedMarketItems}
                  handleChange={handleMarketCheckChange}
                  options={markets}
                  type="market"
                />
              </div>
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-target"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedLlmItems}
                  handleChange={handleLlmCheckChange}
                  options={dbLlms}
                  type="llm"
                />
              </div>
            </div>

            <div className="col-md-4 d-flex align-items-start">
              <Button
                disabled={isFirstTime || (!showData && !isDone)}
                style={{
                  backgroundColor: "gainsboro",
                  borderColor: "gainsboro",
                  color: "black",
                  // textTransform: "capitalize",
                }}
                variant="contained"
                color={"secondary"}
                onClick={handleClickShow}
              >
                Get Input
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardNav;
